<template>
    <el-dialog 
        title="同步商品" 
        :visible.sync="dialogVisible" 
        width="800px"
        :before-close="handleClose"
        @open="onDialogOpen"
    >
        <div class="sync-product-dialog">
            <!-- 电商平台 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">电商平台：</div>
                    <div class="query-item-content">
                        <label class="custom-radio" @click="onPlatformChange('all')">
                            <input type="radio" name="platform" value="all" v-model="filter.platform">
                            <span class="custom-radio-btn">全部</span>
                        </label>
                        <label class="custom-radio" @click="onPlatformChange('shopee')">
                            <input type="radio" name="platform" value="shopee" v-model="filter.platform">
                            <span class="custom-radio-btn">
                                <i class="iconfont" style="color: #E9501E; font-size:18px; margin-right:5px;">&#xe636;</i>Shopee
                            </span>
                        </label>
                    </div>
                </div>
            </div>

            <!-- 地区 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">地区：</div>
                    <div class="query-item-content">
                        <label class="custom-radio" @click="onRegionChange('all')">
                            <input type="radio" name="region" value="all" v-model="filter.region">
                            <span class="custom-radio-btn">全部</span>
                        </label>
                        <label class="custom-radio" @click="onRegionChange('tw')">
                            <input type="radio" name="region" value="tw" v-model="filter.region">
                            <span class="custom-radio-btn">台湾</span>
                        </label>
                    </div>
                </div>
            </div>

            <!-- 店铺 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">店铺：</div>
                    <div class="query-item-content" style="padding-right:20px;">
                        <el-checkbox v-model="selectAllShops" @change="onSelectAllShops">全部</el-checkbox>
                        <el-input type="text" style="width: 150px;" @input="getShops" name="shopName" size="small" placeholder="请输入关键词" v-model="shopKeyword" />
                        <div class="shop-list-container">
                            <div class="shop-list">
                                <div 
                                    v-for="shop in shops" 
                                    :key="shop.id"
                                    class="shop-item"
                                >
                                    <el-checkbox 
                                        :value="selectedShops.includes(shop.id)"
                                        @change="onShopSelect(shop.id, $event)"
                                    >
                                        {{ shop.actualName || shop.name }}
                                        <!-- <span style="color: #999; font-size: 12px;">@{{ shop.ownerName }}</span>
                                        <i class="el-icon-star-on" style="color: #ffd700; margin-left: 5px;"></i> -->
                                    </el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 状态 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">状态：</div>
                    <div class="query-item-content">
                        <label class="custom-radio" @click="onStatusChange('onsale')">
                            <input type="radio" name="status" value="onsale" v-model="filter.status">
                            <span class="custom-radio-btn">在售中</span>
                        </label>
                        <label class="custom-radio" @click="onStatusChange('review')">
                            <input type="radio" name="status" value="review" v-model="filter.status">
                            <span class="custom-radio-btn">审查中</span>
                        </label>
                        <label class="custom-radio" @click="onStatusChange('notlisted')">
                            <input type="radio" name="status" value="notlisted" v-model="filter.status">
                            <span class="custom-radio-btn">未上架</span>
                        </label>
                        <label class="custom-radio" @click="onStatusChange('banned')">
                            <input type="radio" name="status" value="banned" v-model="filter.status">
                            <span class="custom-radio-btn">被禁售</span>
                        </label>
                        <label class="custom-radio" @click="onStatusChange('deleted')">
                            <input type="radio" name="status" value="deleted" v-model="filter.status">
                            <span class="custom-radio-btn">已删除</span>
                        </label>
                    </div>
                </div>
            </div>

            <!-- 更新时间 -->
            <div class="query-row">
                <div class="query-item">
                    <div class="query-item-title">更新时间：</div>
                    <div class="query-item-content">
                        <el-date-picker
                            v-model="filter.updateTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="请选择日期"
                            end-placeholder="请选择日期"
                            size="small"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'SyncProductDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogVisible: false,
            filter: {
                platform: 'all',
                region: 'all',
                status: 'onsale',
                updateTime: []
            },
            shops: [],
            selectedShops: [],
            selectAllShops: false,
            shopKeyword: ''
        }
    },
    watch: {
        visible(val) {
            this.dialogVisible = val;
        },
        dialogVisible(val) {
            this.$emit('update:visible', val);
        }
    },
    methods: {
        onDialogOpen() {
            this.getShops();
        },
        handleClose() {
            this.dialogVisible = false;
            this.resetForm();
        },
        handleConfirm() {
            const params = {
                ...this.filter,
                selectedShops: this.selectedShops
            };
            this.$emit('confirm', params);
            this.handleClose();
        },
        resetForm() {
            this.filter = {
                platform: 'all',
                region: 'all',
                status: 'onsale',
                updateTime: []
            };
            this.selectedShops = [];
            this.selectAllShops = false;
            this.shopKeyword = '';
        },
        onPlatformChange(value) {
            this.filter.platform = value;
        },
        onRegionChange(value) {
            this.filter.region = value;
        },
        onStatusChange(value) {
            this.filter.status = value;
        },
        onSelectAllShops(checked) {
            if (checked) {
                this.selectedShops = this.shops.map(shop => shop.id);
            } else {
                this.selectedShops = [];
            }
        },
        onShopSelect(shopId, checked) {
            if (checked) {
                if (!this.selectedShops.includes(shopId)) {
                    this.selectedShops.push(shopId);
                }
            } else {
                const index = this.selectedShops.indexOf(shopId);
                if (index > -1) {
                    this.selectedShops.splice(index, 1);
                }
            }
            // 更新全选状态
            this.selectAllShops = this.selectedShops.length === this.shops.length;
        },
        getShops(queryString) {
            let param = {
                start: 0,
                type: 0,
                name: queryString || this.shopKeyword,
            }
            
            this.$axios.post(
                this.$kit.api.shop.list, 
                param
            ).then((result) => {
                if(result.status){
                    this.shops = result.data.list.map(d => {
                        return {
                            id: d.shopId,
                            name: d.name,
                            actualName: d.actualName,
                            ownerName: d.ownerName || '未知',
                            type: d.type || '本土'
                        }
                    });
                }
            }).catch(error => {
                console.error('获取店铺列表失败:', error);
                // 使用模拟数据
                this.shops = [
                    { id: 1, name: '貰貝到豕', actualName: '貰貝到豕★劉幸@貢炒鸡', ownerName: '貢炒鸡', type: '本土' },
                    { id: 2, name: '頭號玩家', actualName: '頭號玩家★葉金菊@黃伊娜', ownerName: '黃伊娜', type: '本土' },
                    { id: 3, name: '甜美', actualName: '甜美★劉澤奇@袁文惠', ownerName: '袁文惠', type: '本土' },
                    { id: 4, name: '日日發', actualName: '日日發★陳慧琳@黃妙婷', ownerName: '黃妙婷', type: '本土' },
                    { id: 5, name: 'TS超级商店', actualName: 'TS超级商店★叶未瑛@羅美琪→黃妙婷拍', ownerName: '羅美琪', type: '本土' },
                    { id: 6, name: '小小橘子', actualName: '小小橘子★陳慧琳@袁文惠→曾龙艳拍', ownerName: '袁文惠', type: '本土' },
                    { id: 7, name: '凍結--正發優品', actualName: '凍結--正發優品★梁高毅@吳桐→曾龙艳拍', ownerName: '吳桐', type: '本土' },
                    { id: 8, name: '七號', actualName: '七號★陳慧琳@羅美琪', ownerName: '羅美琪', type: '本土' },
                    { id: 9, name: '兔子工具', actualName: '兔子工具★廖嬋@黃伊娜', ownerName: '黃伊娜', type: '本土' },
                    { id: 10, name: '左鄰右舍', actualName: '左鄰右舍膠殚@維夫坦', ownerName: '維夫坦', type: '本土' },
                    { id: 11, name: '梵顏', actualName: '梵顏★葉未瑛@黃妙婷', ownerName: '黃妙婷', type: '本土' },
                    { id: 12, name: '川島屋', actualName: '川島屋★葉未瑛@黃伊娜', ownerName: '黃伊娜', type: '本土' },
                    { id: 13, name: '結花安選', actualName: '結花安選★葉金菊@袁文惠', ownerName: '袁文惠', type: '本土' },
                    { id: 14, name: '蘋安', actualName: '蘋安★葉未瑛@黃伊娜', ownerName: '黃伊娜', type: '本土' },
                    { id: 15, name: '365Days', actualName: '365Days★葉金菊@黃伊娜', ownerName: '黃伊娜', type: '本土' },
                    { id: 16, name: '印象', actualName: '印象★葉金菊@袁文惠', ownerName: '袁文惠', type: '本土' },
                    { id: 17, name: '步凡', actualName: '步凡★廖嘉鳳@羅美琪', ownerName: '羅美琪', type: '本土' },
                    { id: 18, name: '卓木鸟', actualName: '卓木鸟★叶未瑛@袁文惠', ownerName: '袁文惠', type: '本土' }
                ];
            });
        }
    }
}
</script>

<style scoped>
.sync-product-dialog {
    margin-top: -15px;
    margin-bottom: -20px;
}

.query-row {
    margin-bottom: 15px;
}

.query-item {
    display: flex;
    align-items: top;
}

.query-item-title {
    width: 100px;
    min-width: 100px;
    text-align: right;
    margin-top: 5px;
    font-size: 14px;
}

.query-item-content {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
}

.custom-radio {
    display: inline-block;
    cursor: pointer;
    user-select: none;
}

.custom-radio input[type="radio"] {
    display: none;
}

.custom-radio-btn {
    display: inline-block;
    padding: 1px 12px;
    height: 28px;
    line-height: 29px;
    background: rgba(0,0,0,0.09);
    border-radius: 2px;
    color: #333;
    border: 1px solid transparent;
    transition: all 0.2s;
    font-size: 14px;
}

.custom-radio:hover .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
}

.custom-radio input[type="radio"]:checked + .custom-radio-btn {
    background: #f2f3ff;
    color: #0052d9;
    border: 1px solid #0052d9;
    white-space: nowrap;
}

.shop-list-container {
    width: 100%;
    margin-top: 10px;
}

.shop-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
}

.shop-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    flex: 0 0 auto;
}

.shop-item .el-checkbox {
    width: 100%;
}

.shop-item .el-checkbox__label {
    font-size: 13px;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.dialog-footer {
    text-align: right;
    padding-top: 20px;
    border-top: 1px solid #e8e8e8;
}

.dialog-footer .el-button {
    margin-left: 10px;
}
</style>
